/** Minimal ASCII DXF (R2000-style header) with ENTITIES only — no dxf-writer, full control. */

export function formatDxfDouble(v: number): string {
  if (!Number.isFinite(v)) return '0';
  const s = v.toFixed(6);
  const t = s.replace(/\.?0+$/, '');
  return t === '' || t === '-0' ? '0' : t;
}

export interface MinimalDxfExtents {
  insunits: number;
  extMin: { x: number; y: number };
  extMax: { x: number; y: number };
}

export interface DxfLineSeg {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

export interface DxfCircleEnt {
  cx: number;
  cy: number;
  r: number;
}

export interface DxfPointEnt {
  x: number;
  y: number;
}

/**
 * LINE, CIRCLE, POINT entities only — widest CAM/viewer compatibility.
 */
export function buildMinimalDxf(
  lines: DxfLineSeg[],
  circles: DxfCircleEnt[],
  points: DxfPointEnt[],
  ext: MinimalDxfExtents,
): string {
  const push = (parts: string[], ...row: (string | number)[]) => {
    for (const r of row) parts.push(String(r));
  };
  const out: string[] = [];
  const z = 0;

  push(out, 0, 'SECTION', 2, 'HEADER');
  push(out, 9, '$ACADVER', 1, 'AC1015');
  push(out, 9, '$INSUNITS', 70, ext.insunits);
  push(out, 9, '$EXTMIN', 10, formatDxfDouble(ext.extMin.x), 20, formatDxfDouble(ext.extMin.y), 30, z);
  push(out, 9, '$EXTMAX', 10, formatDxfDouble(ext.extMax.x), 20, formatDxfDouble(ext.extMax.y), 30, z);
  push(out, 0, 'ENDSEC');

  push(out, 0, 'SECTION', 2, 'ENTITIES');

  for (const ln of lines) {
    push(
      out,
      0, 'LINE',
      8, '0',
      10, formatDxfDouble(ln.x1),
      20, formatDxfDouble(ln.y1),
      30, z,
      11, formatDxfDouble(ln.x2),
      21, formatDxfDouble(ln.y2),
      31, z,
    );
  }
  for (const c of circles) {
    push(
      out,
      0, 'CIRCLE',
      8, '0',
      10, formatDxfDouble(c.cx),
      20, formatDxfDouble(c.cy),
      30, z,
      40, formatDxfDouble(c.r),
    );
  }
  for (const p of points) {
    push(out, 0, 'POINT', 8, '0', 10, formatDxfDouble(p.x), 20, formatDxfDouble(p.y), 30, z);
  }

  push(out, 0, 'ENDSEC');
  push(out, 0, 'EOF');

  return out.join('\r\n');
}
